<mat-card class="mt-3">
    <mat-card-header>
        <!-- <div mat-card-avatar class="example-header-image">
            <img *ngIf="currentAsset.host && currentAsset.host.manufacturer && currentAsset.host.icon"
                 [matTooltip]="currentAsset.host.manufacturer"
                 class="mat-32" src="/assets/images/os/{{currentAsset.host.icon}}"
                 alt="{{currentAsset.host.host_name}}">
            <img *ngIf="currentAsset.host && !currentAsset.host.manufacturer && currentAsset.host.icon"
                 class="mat-32" src="/assets/images/os/{{currentAsset.host.icon}}"
                 alt="{{currentAsset.host.host_name}}">
        </div> -->
        <mat-card-subtitle class="mr-3 col-md-12" *ngIf="sourceColumnName && !reportBuilder">
          Total Row(s) Count : {{rowsData && rowsData.length > 0 ? rowsData.length : 0}} <br/>
          Filtered Row Count : {{ filteredRowCount }} 
          <!-- <br />
          Source Column Name: {{sourceColumnName}} -->
        </mat-card-subtitle>

        <ng-container *ngIf="!reportBuilder">
          <mat-form-field class="col-lg-3 mat-small">
            <mat-label>Quick Search (Press Enter To Search)</mat-label>
            <input matTooltip="Press Enter To Search"
                   placeholder="Enter value and press enter to search" matInput name="searchRec"
                   [(ngModel)]="searchRec" (keydown.enter)="applyFilter()">
            <mat-icon class="pointer" (click)="applyFilter()" matSuffix>search</mat-icon>
          </mat-form-field>
          <button mat-mini-fab matTooltip="Clear text" color="basic" (click)="clearSelectedRecords();">
            <a (click)="$event.preventDefault();" href="#"><i class="ms-Icon ms-Icon--Rotate ms-fontColor-themePrimary"></i></a>
          </button>

          <div class="col-md-6 text-right">
            <mat-checkbox #selectedOnly matTooltip="Download Selected Rows Only" [(ngModel)]="checked" class="mr-3 example-margin"></mat-checkbox>
            <!-- <button (click)="cs.clickedAllRecords('checked')" mat-raised-button>
              <a (click)="showAllRecs(); $event.preventDefault();" href="#">
                <span *ngIf="showAll">Show All Recon</span>
                <span *ngIf="!showAll">Show Single Recons</span>
              </a>
            </button>  -->
            <mat-form-field class="mr-2" *ngIf="agGridOption && agGridOption.isUtr">
              <mat-select placeholder="Select UTR" (selectionChange)="changeUTR($event)">
                <input class="p-2 w-100" style="border: none !important" (keyup)="onSearchChange($event)" matTooltip="Search UTR" placeholder="Search utr" name="searchRec" [(ngModel)]="searchValue" (click)="searchValue = ''">
                <mat-option value="">Select utr</mat-option>
                <mat-option *ngFor="let utr of getUTRNumbers" [value]="utr">{{utr}}</mat-option>
              </mat-select>
            </mat-form-field>
            <ng-container *ngIf="glview">
              <button class="mr-2" *ngIf="showAll" (click)="cs.clickedAllRecords('checked'); showAllRecs('checked'); clickedAllRecords('checked');" mat-raised-button> <i class="ms-Icon ms-Icon--Checkbox"></i> Show All Recon</button>
              <button class="mr-2" *ngIf="notshowAll" (click)="cs.clickedAllRecords('unchecked'); showAllRecs('unchecked'); clickedAllRecords('unchecked');" mat-raised-button> <i class="ms-Icon ms-Icon--BoxCheckmarkSolid"></i> Show All Recon</button>
            </ng-container>
              <!-- <mat-checkbox *ngIf="glview" (ngModelChange)="cs.clickedAllRecords($event)" matTooltip="Show All Records" class="mr-2 example-margin">All Records</mat-checkbox> -->
            <button *ngIf="glview" mat-mini-fab class="mr-2" color="basic" matTooltip="Refresh Table" (click)="cs.refreshTable(); $event.preventDefault();">
              <a (click)="$event.preventDefault();" href="#"><i class="ms-Icon ms-Icon--Refresh"></i></a>
            </button> 
            <button *ngIf="checked" [matMenuTriggerFor]="srMenu" color="basic" mat-mini-fab class="mr-2" matTooltip="Download Selected Records">
              <a href="#" (click)="$event.preventDefault();"><i class="ms-Icon ms-Icon--CloudDownload ms-fontColor-themePrimary"></i></a>
            </button>
            <mat-menu class="mat_menu" #srMenu="matMenu">
              <button matTooltip="download as .xlsx" color="basic" mat-menu-item (click)="downloadSelectedRecords('excel')">
                <span class="pointer"><img src="../../../assets/images/microsoft-excel.png" alt="Excel" class="mat-32"></span> Excel
              </button>
              <button matTooltip="download as .csv" color="basic" mat-menu-item (click)="downloadSelectedRecords('csv')">
                <span class="pointer"><img src="../../../assets/images/csv.png" alt="CSV" class="mat-32"></span> Csv
              </button>
            </mat-menu>
            <button *ngIf="!checked" mat-mini-fab color="basic" class="mr-2" [matMenuTriggerFor]="menu" matTooltip="Download All Records">
              <a href="#" (click)="$event.preventDefault();"><i class="ms-Icon ms-Icon--CloudDownload ms-fontColor-themePrimary"></i></a>
            </button>
            <mat-menu class="mat_menu" #menu="matMenu">
                <button matTooltip="download as .xlsx" color="basic" mat-menu-item (click)="downloadAllRecordsAgGrid('excel')">
                  <span class="pointer"><img src="../../../assets/images/microsoft-excel.png" alt="Excel" class="mat-32"></span> Excel
                </button>
                <button matTooltip="download as .csv" color="basic" mat-menu-item (click)="downloadAllRecordsAgGrid('csv')">
                  <!-- <img class="donwload" src="../../../assets/images/reports/csv.png" alt="csv" /> -->
                  <span class="pointer"><img src="../../../assets/images/csv.png" alt="CSV" class="mat-32"></span> Csv
                </button>
            </mat-menu>
            <button mat-mini-fab class="mr-2" color="basic" matTooltip="Save Remarks">
              <a (click)="saveRemarks(); $event.preventDefault();" href="#"><i class="ms-Icon ms-Icon--Save ms-fontColor-themePrimary"></i></a>
            </button>
            <button mat-mini-fab class="" color="basic" matTooltip="Save Table" (click)="saveGridTableSettings(); $event.preventDefault();">
              <a (click)="$event.preventDefault();" href="#"><i class="ms-Icon ms-Icon--Table"></i></a>
            </button> 
            <!--  cs.saveTableFromAgGrid(); -->
            <!-- <button mat-mini-fab class="mr-2" color="basic" matTooltip="Add Column">
              <a (click)="cs.addColumnFromAgGrid(); $event.preventDefault();" href="#"><mat-icon>add_box</mat-icon></a>
            </button> -->
            <!-- <button mat-mini-fab color="basic" matTooltip="All Filter">
              <a (click)="selectAllFiltered($event); $event.preventDefault();" href="#"><mat-icon>checkbox</mat-icon></a>
            </button> -->
          </div>
        </ng-container>
        <ng-container *ngIf="reportBuilder">
          <mat-form-field class="col-lg-4 mat-small">
            <mat-label>Quick Search (Press Enter To Search)</mat-label>
            <input matTooltip="Press Enter To Search"
                   placeholder="Enter value and press enter to search" matInput name="searchRec"
                   [(ngModel)]="searchRec" (keydown.enter)="applyFilter()">
            <mat-icon class="pointer" (click)="applyFilter()" matSuffix>search</mat-icon>
          </mat-form-field>
          <button mat-mini-fab matTooltip="Clear text" color="basic">
            <a (click)="clearSelectedRecords(); $event.preventDefault();" href="#"><mat-icon>clear</mat-icon></a>
          </button>

          <div class="col-md-7 text-right">
            <mat-checkbox #selectedOnly matTooltip="Download Selected Rows Only" [(ngModel)]="checked" class="mr-3 example-margin"></mat-checkbox>
            <button *ngIf="checked" [matMenuTriggerFor]="srMenu" color="basic" mat-mini-fab class="mr-2" matTooltip="Download Selected Records">
              <a href="#" (click)="$event.preventDefault();"><mat-icon>cloud_download</mat-icon></a>
            </button>
            <mat-menu class="mat_menu" #srMenu="matMenu">
              <button matTooltip="download as .xlsx" color="basic" mat-menu-item (click)="downloadSelectedRecords('excel')">
                Excel
              </button>
              <button matTooltip="download as .csv" color="basic" mat-menu-item (click)="downloadSelectedRecords('csv')">
                Csv
              </button>
            </mat-menu>
            <button mat-mini-fab class="mr-2" color="basic" matTooltip="Add Column">
              <a (click)="cs.addColumnFromAgGrid(); $event.preventDefault();" href="#"><mat-icon>add_box</mat-icon></a>
            </button>
            <button *ngIf="!checked" mat-mini-fab color="basic" class="mr-2" [matMenuTriggerFor]="menu" matTooltip="Download All Records">
              <a href="#" (click)="$event.preventDefault();"><mat-icon>cloud_download</mat-icon></a>
            </button>
            <mat-menu class="mat_menu" #menu="matMenu">
              <button matTooltip="download as .xlsx" color="basic" mat-menu-item (click)="downloadAllRecordsAgGrid('excel')">
                Excel
              </button>
              <button matTooltip="download as .csv" color="basic" mat-menu-item (click)="downloadAllRecordsAgGrid('csv')">
                <!-- <img class="donwload" src="../../../assets/images/reports/csv.png" alt="csv" /> -->
                Csv
              </button>
            </mat-menu>
            <button mat-mini-fab color="basic" matTooltip="Save Remarks">
              <a (click)="saveForReportBuilder(); $event.preventDefault();" href="#"><mat-icon>save</mat-icon></a>
            </button>
          </div>
        </ng-container>
    </mat-card-header>

    <mat-card-content>
      <!-- <pre>{{ rowsData[0] | json }}</pre> -->
        <ag-grid-angular *ngIf="reconview"
          #agGrid
          id="myGrid"
          style="width: 100%; height: 500px;"
          class="ag-theme-alpine"
          [allowDragFromColumnsToolPanel]="true"
          [autoGroupColumnDef]="autoGroupColumnDef"
          [columnDefs]="columnDefs"
          [columnTypes]="columnTypes"
          [cacheQuickFilter]="true"
          [defaultColDef]="defaultColDef"
          [rowSelection]="rowSelection"
          [groupSelectsChildren]="true"
          [groupSelectsFiltered]="true"
          [gridOptions]="gridOptions"
          [rowData]="rowsData"
          [rowMultiSelectWithClick]="true"
          [rowGroupPanelShow]="rowGroupPanelShow"
          [sideBar]="true"
          [suppressFieldDotNotation]="true"
          [suppressAggFuncInHeader]="true" 
          [suppressRowClickSelection]="true"
          [undoRedoCellEditing]="true"
          (filterChanged)="onFilterChanged($event)"
          (cellValueChanged)="onCellValueChanged($event)"
          (cellClicked)="onCellClicked($event)"
          (gridReady)="onGridReady($event, 'reconview')"
          (selectionChanged)="onSelectionChanged($event);"
          (columnRowGroupChanged)="onColumnRowGroupChanged($event)"
        >
        </ag-grid-angular>
         <!-- ! [rowMultiSelectWithClick]="true" -->
        <ag-grid-angular *ngIf="glview"
          #glGrid
          id="glGrid"
          style="width: 100%; height: 500px;"
          class="ag-theme-alpine"
          [allowDragFromColumnsToolPanel]="true"
          [autoGroupColumnDef]="autoGroupColumnDef"
          [columnDefs]="columnDefs"
          [columnTypes]="columnTypes"
          [cacheQuickFilter]="true"
          [defaultColDef]="defaultColDef"
          [groupSelectsChildren]="true"
          [gridOptions]="gridOptions"
          [rowData]="rowData"

          [getRowStyle]="getRowStyle"
          
          [rowGroupPanelShow]="rowGroupPanelShow"
          [sideBar]= "true"
          [suppressFieldDotNotation]="true"
          [suppressAggFuncInHeader]="true" 
          [suppressRowClickSelection]="true"
          [undoRedoCellEditing]="true"
          (filterChanged)="onFilterChanged($event)"
          (cellValueChanged)="onCellValueChanged($event)"
          (cellClicked)="cs.glClickedEvent($event.data, $event.colDef)"
          (gridReady)= "onGridReady($event, 'glview')"
          (selectionChanged)="onSelectionChanged($event);"
          (columnRowGroupChanged)="onColumnRowGroupChanged($event)"
        >
        </ag-grid-angular>
    </mat-card-content>
</mat-card>

